// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".55379ddc4cccb4b662840f698f2535bce11ee631.chunk.js";
};